<template>
  <div class="common-calendar">
    <div class="ms-container-header">
      <icon size="16" type="md-calendar" />
      Календарь
    </div>
    <div class="common-calendar__container">
      <v-calendar
        :columns="2"
        :attributes="attributes"
        is-expanded
        :is-dark="theme === 'dark'"
        locale="ru"
        :disabled-dates="disabledDates"
      />
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils'

export default {
  props: ['tasks', 'holidays'],
  computed: {
    theme () {
      return this.$store.state.theme
    },
    disabledDates () {
      return this.holidays.map(d => new Date(d))
    },
    attributes () {
      return [
        {
          key: 'today',
          dates: new Date(),
          dot: 'indigo',
          popover: {
            visibility: 'hover',
            placement: 'right',
            label: 'Сегодня'
          }
        },
        ...this.tasks.map(t => ({
          key: t.id,
          contentStyle: {
            color: '#fafafa'
          },
          props: t,
          ...this.getStyleObject(t)
        }))
      ]
    }
  },
  methods: {
    getStyleObject (task) {
      return {
        dates: new Date(formatDate(task.expiration_date, 'YYYY-MM-DD')),
        highlight: 'blue',
        popover: {
          visibility: 'hover',
          placement: 'right',
          label: `${task.object.code}. ${task.name}`
        }
      }

      // switch (task.type) {
      //   case 'acts':
      //     return {
      //       dates: new Date(formatDate(task.send_date, 'DD.MM.YYYY')),
      //       highlight: 'blue',
      //       popover: {
      //         visibility: 'hover',
      //         placement: 'right',
      //         label: `${task.contract_code}. Акт №${task.number}`
      //       }
      //     }
      //   case 'law_cases':
      //     return {
      //       dates: [
      //         {
      //           start: new Date(formatDate(task.start_date)),
      //           end: task.end_date
      //             ? new Date(formatDate(task.end_date))
      //             : new Date()
      //         }
      //       ],
      //       highlight: 'indigo',
      //       popover: {
      //         visibility: 'hover',
      //         placement: 'right',
      //         label: `${task.contract_code}. Судебное дело`
      //       }
      //     }
      //   case 'contragents':
      //     return {
      //       dates: new Date(formatDate(task.start_date)),
      //       highlight: 'purple',
      //       popover: {
      //         visibility: 'hover',
      //         placement: 'right',
      //         label: `${task.main_contract_code}. ${task.performer} ожидает оплаты`
      //       }
      //     }
      //   case 'roadmap':
      //     return {
      //       dates: new Date(formatDate(getRoadmapState(task).date)),
      //       highlight: 'green',
      //       popover: {
      //         visibility: 'hover',
      //         placement: 'right',
      //         label: `${task.contract.code}. Этап - ${task.name}. ${
      //           getRoadmapState(task).status
      //         }`
      //       }
      //     }
      //   case 'procedures':
      //     return {
      //       dates: new Date(formatDate(task.receive_date)),
      //       highlight: 'pink',
      //       popover: {
      //         visibility: 'hover',
      //         placement: 'right',
      //         label: `${task.contract_code}. ${task.procedure_type_name}`
      //       }
      //     }
      //   case 'prepaids':
      //     return {
      //       dates: new Date(formatDate(task.prepayed_start_date)),
      //       highlight: 'teal',
      //       popover: {
      //         visibility: 'hover',
      //         placement: 'right',
      //         label: `${task.contract_code}. Получение аванса`
      //       }
      //     }
      // }
    }
  }
}
</script>

<style lang="less">
</style>
